import { mockFiles } from '@/components/Tutorial/mocks/filesMock';
import { File } from '../types/file.types';
import { useTour } from '@reactour/tour';
import { useAppSelector } from '@/store/hooks';
import { selectFilesParams } from './useFilesQuery';

interface MockFilesResponse {
  documents: File[];
  total_count: number;
}

export const useMockFiles = (): {
  data: MockFilesResponse | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refetch: () => void;
} => {
  const { isOpen } = useTour();
  const params = useAppSelector(selectFilesParams);

  // Simuler un délai de chargement uniquement si le tour n'est pas ouvert
  const isLoading = !isOpen;
  const isFetching = false;
  const error = null;

  const filteredFiles = mockFiles.filter((file) => {
    // Appliquer tous les filtres de manière cumulative
    const matchesFilters = params.filters.every((filter) => {
      switch (filter) {
        case 'isLowRisk':
          return file.risque === 0;
        case 'isMediumRisk':
          return file.risque === 1;
        case 'isHighRisk':
          return file.risque === 2;
        case 'isUnread':
          return !file.lu;
        case 'isFavorite':
          return file.favori;
        case 'isArchived':
          return file.archive;
        default:
          return true;
      }
    });

    // Appliquer la recherche si elle existe
    const matchesSearch =
      !params.search ||
      file.nom.toLowerCase().includes(params.search.toLowerCase());

    return matchesFilters && matchesSearch;
  });

  const data: MockFilesResponse = {
    documents: filteredFiles,
    total_count: filteredFiles.length,
  };

  return {
    data,
    isLoading,
    isFetching,
    error,
    refetch: () => {},
  };
};
